import { useMemo } from 'react';
import { useQriResolve } from './useQriResolve';
import { useRetrieveTasks } from './useRetrieveTasks';
import { useUsers } from './useUsers';
import { ResolvedTask } from './types';

export const useRetrieveTaskList = (): {
  total: number;
  tasks: ResolvedTask[];
  isLoading: boolean;
} => {
  const { isLoading, tasks, total } = useRetrieveTasks();
  const { isLoading: isUserLoading, data } = useUsers();
  const { isLoading: isLoadingQRI, data: qriData } = useQriResolve(
    (tasks ?? []).map((task) => task.parent_qri),
  );

  const tasksResolved = useMemo((): ResolvedTask[] => {
    if (!qriData) {
      return [];
    }

    return tasks.map(
      (task): ResolvedTask => ({
        ...task,
        source: {
          label: qriData[task.parent_qri].displayLabel,
          domain: qriData[task.parent_qri].domain,
          link: qriData[task.parent_qri].identifiers.qri,
        },
        assignee: data?.usersById[task.creator_id].full_name ?? '',
      }),
    );
  }, [tasks, qriData, data]);

  return {
    total,
    tasks: tasksResolved,
    isLoading: isLoading || isUserLoading || isLoadingQRI,
  };
};
